import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const feeApi = createApi({
    reducerPath: 'tarifas',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['GIROS', 'PATENTES', 'SERVICIOS'],
    endpoints: (builder) => ({
        getTarifasGiros: builder.query({
            query: () => ({
                url: 'giros/codigos-tarifa'
            }),
            transformResponse: (response: { data: { codigos: any } }) => response?.data?.codigos,
            providesTags: ['GIROS']
        }),
        getTarifasPatentes: builder.query({
            query: () => ({
                url: 'patentes/codigos-tarifa'
            }),
            transformResponse: (response: { data: { codigos: any } }) => response?.data?.codigos,
            providesTags: ['PATENTES']
        }),
        getTarifasServiciosNave: builder.query({
            query: () => ({
                url: 'servicios-nave/datos-parametricos/codigos-tarifa'
            }),
            transformResponse: (response: { data: { codigos: any } }) => response?.data?.codigos,
            providesTags: ['SERVICIOS']
        }),
        addFee: builder.mutation({
            query: ({ data }) => ({
                url: 'tarifas',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (a, error, data) => {
                const value: 'GIROS' | 'PATENTES' | 'SERVICIOS' = data?.data?.tipoTarifa;

                return error ? [] : [`${value}`];
            }
        }),
        editFee: builder.mutation({
            query: ({ data, feeId }) => ({
                url: `tarifas/${feeId}`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: (a, error, data) => {
                const value: 'GIROS' | 'PATENTES' | 'SERVICIOS' = data?.data?.tipoTarifa;

                return error ? [] : [`${value}`];
            }
        })
    })
});

export const {
    useGetTarifasGirosQuery,
    useGetTarifasPatentesQuery,
    useGetTarifasServiciosNaveQuery,
    useAddFeeMutation,
    useEditFeeMutation
} = feeApi;
